var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/wrapped-well-known-symbol.js
// module id = T40b
// module chunks = 0